import "./Styles.css";
import { useState } from "react";
import "@fontsource/figtree"; // Defaults to weight 400
import "@fontsource/figtree/400.css"; // Specify weight
import "@fontsource/figtree/400-italic.css"; // Specify weight and style
import CustomRouter from "../src/router/customRouter"
import { Loader } from "@bsf/force-ui";

const App = () =>  {
  const [loaded, setLoaded] = useState(false);
  
  return (
    <div className="App">
      <CustomRouter />
    </div>
  );
}

export default App;
